const isSingleService = (mapping) => !!(mapping && mapping.serviceLevel && mapping.serviceLevel.typeSelected === 'single-service');

export default isSingleService;
